export default "__VITE_ASSET__a48de777__"